<template>
  <div>
    <v-tooltip :top="pos == 1" :right="pos == 2" :bottom="pos == 3" :left="pos == 4" :z-index="tipzidx">
      <v-avatar :slot="tip ? 'activator' : ''" :size="size" :class="elevation ? `elevation-${elevation}` : ''">
        <c-img :src="cover" />
      </v-avatar>
      <template>
        <span>{{ name || $T('common.role.retired') }}</span>
      </template>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    postId: { type: Number, required: true },
    name: { type: String, required: false },

    size: { type: Number, required: false, default: 20 },
    pos: { type: Number, required: false, default: 1 },
    tipzidx: { type: Number, required: false, default: 2000 },
    elevation: { type: Number, required: false, default: 0 },
    tip: { type: Boolean, required: false, default: true },
  },
  data() {
    return {};
  },
  computed: {
    cover() {
      return '/cover/post/' + this.postId;
    },
  },
};
</script>
